module.exports = __webpack_public_path__ + "d8f46d1698c1ba3444cf650587551507.svg";